// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"606":"73210a5c","787":"aee9d2ed","891":"8dcd2ffc"}[chunkId] + ".chunk.js";
};